import { Login } from '../components/ui/login';

const Signup = () => {
  return (
    <Login />
  );
};

export default Signup;
